import { useEffect, useRef, useState } from "react";
import { realtimeBase } from "./fixtures";

/**
 * Simulated realtime visitor count. Real wiring would subscribe to
 * analytics-svc's live stream; here we drift a baseline so the live ribbon
 * feels alive. Returns the current count and a tiny rolling history.
 */
export function useLiveVisitors(base = realtimeBase) {
  const [count, setCount] = useState(base);
  const [pulse, setPulse] = useState(0);
  const history = useRef<number[]>(Array.from({ length: 24 }, () => base));

  useEffect(() => {
    const id = window.setInterval(() => {
      setCount((c) => {
        const drift = Math.round((Math.random() - 0.45) * 5);
        const next = Math.max(4, c + drift);
        history.current = [...history.current.slice(1), next];
        return next;
      });
      setPulse((p) => p + 1);
    }, 2200);
    return () => window.clearInterval(id);
  }, []);

  return { count, pulse, history: history.current };
}

/** A single live event ticking in for the realtime stream. */
export interface LiveEvent {
  id: number;
  label: string;
  page: string;
  city: string;
}

const EVENT_VERBS = ["viewed", "clicked CTA on", "scrolled", "started form on", "converted on"];
const PAGES = ["/", "/pricing", "/studio", "/nara", "/blog/replay"];
const CITIES = ["Austin", "London", "Berlin", "Baku", "Toronto", "Paris", "Mumbai", "Lisbon"];

export function useLiveEvents(max = 8) {
  const [events, setEvents] = useState<LiveEvent[]>([]);
  const seq = useRef(0);
  useEffect(() => {
    const push = () => {
      seq.current += 1;
      const e: LiveEvent = {
        id: seq.current,
        label: EVENT_VERBS[Math.floor(Math.random() * EVENT_VERBS.length)]!,
        page: PAGES[Math.floor(Math.random() * PAGES.length)]!,
        city: CITIES[Math.floor(Math.random() * CITIES.length)]!,
      };
      setEvents((prev) => [e, ...prev].slice(0, max));
    };
    push();
    const id = window.setInterval(push, 1800);
    return () => window.clearInterval(id);
  }, [max]);
  return events;
}
